<script setup lang="ts">
import { Card } from '@toruslabs/vue-components/Card';
import { computed, onMounted, ref } from 'vue';
import { useControllerStore } from '../store/controllerStore';
import { useClaimStore } from '../store/claimStore';
import { Loader } from "../components/Loader";

// Claim Components (left side)
import IntroMocaverse from '../components/Claim/IntroMocaverse.vue';
import WhyMoca from '../components/Claim/WhyMoca.vue';
import ExploreMocaverse from '../components/Claim/ExploreMocaverse.vue';

// Claim Components (right side)
import CheckInviteCode from '../components/Claim/CheckInviteCode.vue';
import CheckMoca from '../components/Claim/CheckMoca.vue';
import ChooseClaimMethod from '../components/Claim/ChooseClaimMethod.vue';
import ClaimMocaID from '../components/Claim/ClaimMocaID.vue';
import ClaimMocaIDSuccess from '../components/Claim/ClaimMocaIDSuccess.vue';
import ClaimQuotaFull from '../components/Claim/ClaimQuotaFull.vue';
import CreateWallet from '../components/Claim/CreateWallet.vue';
import ErrorMessage from '../components/Claim/ErrorMessage.vue';
import LinkPartner from '../components/Claim/LinkPartner.vue';

// Assets
import MocaIDLogo from '../assets/claim/moca-id-logo.svg';

const isLoading = ref(false);

const useController = useControllerStore();
const claimStore = useClaimStore();

const leftSide = computed(() => claimStore.leftSide);
const rightSide = computed(() => claimStore.rightSide);
const errorText = computed(() => claimStore.errorText);

onMounted(async () => {
    const address = useController.torusState.PreferencesControllerState.selectedAddress;
    if (address) {
        isLoading.value = true;
        await claimStore.checkEligibility();
        isLoading.value = false;
    }
});
</script>

<template>
    <div class="min-h-screen flex flex-col items-center justify-center">
        <div v-if="isLoading">
            <Loader />
        </div>
        <div v-else class="w-full tab:max-w-screen-tab">
            <Card :classes="{ container: 'group-container !rounded-2xl p-8 !bg-moca-bg !border-none' }">
                <div v-if="rightSide !== 'ChooseClaimMethod'"
                    class="flex flex-col-reverse tab:flex-row items-stretch justify-center gap-6">
                    <!-- Left Side -->
                    <Card class="w-full tab:w-5/12 h-full"
                        :classes="{ container: 'group-container !rounded-2xl !bg-moca-card-id !border-none px-6 py-9 tab:!bg-moca-transparent' }">
                        <IntroMocaverse v-if="leftSide === 'WhatIsMoca'" />
                        <WhyMoca v-if="leftSide === 'WhyMoca'" />
                        <ExploreMocaverse v-if="leftSide === 'ExploreMocaverse'" />
                    </Card>
                    <!-- Right Side -->
                    <Card class="w-full tab:w-7/12 h-full tab:min-h-[500px]"
                        :classes="{ container: 'group-container !rounded-2xl !bg-moca-transparent !border-none tab:px-6 py-7 tab:!bg-moca-card-id' }">
                        <div v-if="!errorText">
                            <CreateWallet v-if="rightSide === 'CreateWallet'" />
                            <CheckInviteCode v-if="rightSide === 'CheckInviteCode'" />
                            <CheckMoca v-if="rightSide === 'CheckMoca'" />
                            <ClaimMocaID v-if="rightSide === 'ClaimMocaID'" />
                            <LinkPartner v-if="rightSide === 'LinkPartner'" />
                            <ClaimQuotaFull v-if="rightSide === 'ClaimQuotaFull'" />
                            <ClaimMocaIDSuccess v-if="rightSide === 'ClaimMocaIDSuccess'" />
                        </div>
                        <ErrorMessage v-if="errorText" class="h-full" />
                    </Card>
                    <img class="h-6 mx-auto tab:hidden" :src="MocaIDLogo" />
                </div>
                <ChooseClaimMethod v-if="rightSide === 'ChooseClaimMethod'" />
            </Card>
        </div>
    </div>
</template>
